module.exports = __webpack_public_path__ + "static/media/MUST-MATIC.f0e93033.png";